import { BlankModal, Icon } from "@components/library";
import Button from "@components/library/Buttons/Button";
import { BlankModalProps } from "@components/library/ModalBases/BlankModal";
import { COLORS, FONTS } from "@constants";
import useFollowRequest from "@hooks/useFollowRequest";
import { RequestForStartupsShowResponse } from "@tsTypes/request_for_startups/show";
import dayjs from "dayjs";
import styled from "styled-components";

interface Props extends BlankModalProps {
  request: RequestForStartupsShowResponse;
}

const NotifyModal = ({ request, isOpen, onClose }: Props) => {
  const { handleFollowRequest, isUserFollowing } = useFollowRequest(
    request.id,
    true /* shouldSkipFollowOnRedirect */
  );

  return (
    <BlankModal onClose={onClose} isOpen={isOpen} width="540px" backgroundMode="blur">
      <ModalContent data-testid="notify-modal">
        <Icon name="Notification Filled" margin="10px auto 0" />
        <Header>Stay in the loop</Header>
        <SubHeader>
          {request.requestable.launch_date && !request.requestable.unknown_launch_date
            ? `Thanks for your interest in ${
                request.title
              }. Get notified when applications open on ${dayjs(
                request.requestable.launch_date
              ).format("MMM D, YYYY")}.`
            : `Thanks for your interest in ${request.title}. Get notified when applications open.`}
        </SubHeader>
        {isUserFollowing ? (
          <SuccessText data-testid="notify-success-text">
            <Icon name="Success" color={COLORS.GREEN} size="sm" />
            You&apos;ll be notified.
          </SuccessText>
        ) : (
          <Button
            width="100%"
            leftIconName="Bell"
            onClick={handleFollowRequest}
            data-testid="notify-me-button"
          >
            Notify me
          </Button>
        )}
      </ModalContent>
    </BlankModal>
  );
};

export default NotifyModal;

const ModalContent = styled.div`
  text-align: center;
  justify-content: center;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 93px;
  width: 100%;
  height: 100%;
`;
const Header = styled.h3`
  color: ${COLORS.BLACK};
  ${FONTS.HEADING_3_SEMIBOLD};
  margin: 4px 0px 0px 0px;
`;
const SubHeader = styled.h6`
  width: 355px;
  color: ${COLORS.NEUTRAL_500};
  ${FONTS.REGULAR_2}
`;
const SuccessText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 42px;
  color: ${COLORS.GREEN};
  ${FONTS.REGULAR_2}
`;
